/*! @onviobr/nucleus-form-builder - v4.2.12 - Copyright 2019 Thomson Reuters™. All rights reserved. */(function(angular) {
    'use strict';

    angular.module('nucleusPermissionsForm', ['@onviobr/nucleus.form.builder.permissions-form.templates', 'pascalprecht.translate'])
        .directive('nucleusPermissionsForm', PermissionsFormDirective)
        .directive('nucleusPermissionsFormRow', PermissionsFormRowDirective);

    function PermissionsFormDirective() {
        return {
            restrict: 'E',
            scope: {
                schema: '=',
                readOnly: '=?'
            },
            templateUrl: 'components/permissions-form/permissions-form.2js.html',
            controller: PermissionsFormCtrl
        };
    }

    function hasArrayValue(arr, val) {
        // if array doesn't exist or is empty, return false
        return !!(arr && angular.isArray(arr) && arr.indexOf(val) > -1);
    }

    function hasOption(node, option) {
        return hasArrayValue(node.options, option);
    }

    function hasChildren(node) {
        return !!(node.children && angular.isArray(node.children) && node.children.length);
    }

    function isType(node, type) {
        if (!node.type) { return false; }
        if (angular.isArray(type)) {
            return type.indexOf(node.type) > -1;
        }
        return node.type === type;
    }

    function hasValidValue(node, value) {
        // NOTE: to keep this general, if no options are specified then any are valid
        // data integrity checks occur at service layer
        if (!node.options || !node.options.length) { return true; }
        return hasArrayValue(node.options, value);
    }

    /* In a perfect world you'd synchronize model values via observation.
       That is inefficient with current angular techniques as we are effectively
       watching every node's properties in a large tree. And so it is handled here
       in the controller and would have to be duplicated in other controllers.
       Luckily at the moment this is the only place we need this behavior. */
    function syncDescendantRowValues(node, value, on, noSib) {
        if (!node.children) { return; }
        node.children.forEach(function (node) {
            getOrSetRowValue(node, value, on, noSib);
            syncDescendantRowValues(node, value, on, noSib);
        });
    }

    function getOrSetRowValue(node, value, on, noSync) {
        // getter
        if (angular.isUndefined(on)) {
            return hasArrayValue(node.value, value);
        }

        // setter
        if (hasValidValue(node, value)) {
            // create value array if necessary
            if (!node.value || !angular.isArray(node.value)) { node.value = []; }
            var i = node.value.indexOf(value);
            if (!on && i > -1) {
                node.value.splice(i,1);
            } else if (on && i === -1) {
                node.value.push(value);
            }
            // update siblings
            if (noSync !== false) {
                if (value === 'FULL') {
                    fullRowOptionToggled(node, on);
                } else {
                    notFullRowOptionToggled(node, on);
                }
                // update descendents
                syncDescendantRowValues(node, value, on);
            }
        }
    }

    function fullRowOptionToggled(node, on) {
        if (on === true) {
            getOrSetRowValue(node, 'VIEW', true);
            getOrSetRowValue(node, 'ADD', true);
            getOrSetRowValue(node, 'EDIT', true);
            getOrSetRowValue(node, 'DELETE', true);
        } else if (on === false) {
            delete node.value;
        }
    }

    function notFullRowOptionToggled(node, on) {
        if (on === true) {
            // if has all, toggle full on
            if (node.options && (node.options.length - 1 === node.value.length) && !hasArrayValue(node.value, 'FULL')) {
                getOrSetRowValue(node, 'FULL', true, false);
            }
        } else if (on === false) {
            // disable sib/desc syncing (final param)
            getOrSetRowValue(node, 'FULL', false, false);
        }
    }

    function visitDescendants(node, fn) {
        if (!fn || !node.children) { return node; }
        node.children.forEach(function(child) {
            fn(child);
            visitDescendants(child, fn);
        });
        return node;
    }

    function visitAncestors(node, fn) {
        if (!fn || !node.parent) { return node; }
        fn(node.parent);
        visitAncestors(node.parent, fn);
        return node;
    }

    /* In a perfect world you'd synchronize model values via observation.
       That is inefficient with current angular techniques as we are effectively
       watching every node's properties in a large tree. And so it is handled here
       in the controller and would have to be duplicated in other controllers.
       Luckily at the moment this is the only place we need this behavior. */
    function syncDownstreamToggles(node) {
        var targetValue = node.value;
        // sync downstream
        visitDescendants(node, function(node) {
            // ignore all except permToggle children of permToggles
            if (node.type !== 'permToggle' || node.parent.type !== 'permToggle') { return; }
            node.value = targetValue;
        });
    }
    function syncUpstreamToggles(node) {
        visitAncestors(node, function(node) {
            // ignore all except permToggle parents of permToggles
            if (node.type !== 'permToggle') { return; }
            var childValues = [];
            node.children.forEach(function(child) {
                if (child.type !== 'permToggle') { return; }
                childValues.push(child.value);
            });
            var equalValues = false;
            childValues.every(function(value) {
                equalValues = childValues[0] === value;
                return equalValues;
            });
            if (equalValues) {
                node.value = childValues[0];
            } else {
                node.value = 'SOME';
            }
        });
    }

    function formatNodeTitleForAttrib(title) {
        return title.replace(/\s/g, '').toLowerCase();
    }

    function PermissionsFormCtrl($rootScope, $scope, $translate, $q, $timeout, bmPermission, bmAccess) {
        $scope.newSelectedTabId = '';
        $scope.strings = {};
        $scope.hasOption = hasOption;
        $scope.hasChildren = hasChildren;
        $scope.isType = isType;
        $scope.showDetails = {};
        $scope.showDetailsDirty = {};
        $scope.formatNodeTitleForAttrib = formatNodeTitleForAttrib;

        getSideNavPermission().then(function (resp) {
            $scope.useSideNav = resp;
        });

        $scope.$watchCollection('schema', function(schema) {
            if (schema.length > 0 && $scope.useSideNav) {
                var sideNavData = [];
                for (var i = 0; i < schema.length; i++) {
                    sideNavData.push({
                        id: schema[i].displayName,
                        label: $scope.translateTabName(schema[i].displayName),
                        qeId: 'bmstaff-permgrpsdetail-' + formatNodeTitleForAttrib(schema[i].displayName) + '-tab'
                    });
                }
                sideNavData[0].selected = true;
                $scope.tabSelected(schema[0]);
                $scope.activeNode = schema[0];
                $scope.sideNavData = sideNavData;
            }
        });

        $scope.translateTabName = function(name) {
            return $scope.strings['tabs.' + name.toLowerCase().replace(/ /g, '')];
        };

        $scope.sideNavItemSelected = function(item) {
            var node;
            for (var i = 0; i < $scope.schema.length; i++) {
                if (item.id === $scope.schema[i].displayName) {
                    node = $scope.schema[i];
                }
            }
            $scope.activeNode = node;
            $scope.tabSelected(node);
        };

        $scope.tabSelected = function(node) {
            $scope.newSelectedTabId = node.displayName.replaceAll(' ', '-');
            $scope.$emit('nucleus-permissions-form-tab-select', node);
        };

        $scope.$watch('newSelectedTabId', function(_, oldValue) {
            if (oldValue !== '') {
                $timeout(function() {
                    var element = document.getElementById($scope.newSelectedTabId);
                    if (element) {
                        element.focus();
                    }
                }, 100);
            }
        });

        $scope.none = function() {
            syncDownstreamToggles(this.node);
            syncUpstreamToggles(this.node);
        };
        $scope.all = function() {
            syncDownstreamToggles(this.node);
            syncUpstreamToggles(this.node);
        };
        $scope.some = function() {
            syncUpstreamToggles(this.node);
        };

        $scope.full = function(newValue) {
            return getOrSetRowValue(this.node, 'FULL', newValue);
        };
        $scope.view = function(newValue) {
            return getOrSetRowValue(this.node, 'VIEW', newValue);
        };
        $scope.add = function(newValue) {
            return getOrSetRowValue(this.node, 'ADD', newValue);
        };
        $scope.edit = function(newValue) {
            return getOrSetRowValue(this.node, 'EDIT', newValue);
        };
        $scope.delete = function(newValue) {
            return getOrSetRowValue(this.node, 'DELETE', newValue);
        };

        function getSideNavPermission() {
            return $q.all([
                bmPermission.has('Internal.SidenavTree').catch(function() { return false; }),
                bmAccess.has('OnvioCenterRevertSideNavEnhancements').catch(function() { return false; })
            ]).then(function(perms) {
                return perms[0] && !perms[1];
            });
        }

        // translate promise doesn't resolve on browser refresh unless delayed till next cycle
        var translateDynamicStrings = function() {
            // NOTE: when adding new tabs, follow pattern below
            // (i.e. remove displayName spaces, make lower case, add namespaced prefix)
            var transPromise = $translate([
                    'nucleus.form.builder.perms.nothing',
                    'nucleus.form.builder.perms.everything',
                    'nucleus.form.builder.perms.custom',
                    'nucleus.form.builder.perms.full',
                    'nucleus.form.builder.perms.view',
                    'nucleus.form.builder.perms.add',
                    'nucleus.form.builder.perms.edit',
                    'nucleus.form.builder.perms.delete',
                    'nucleus.form.builder.perms.tabs.documents',
                    'nucleus.form.builder.perms.tabs.mypayonboarding',
                    'nucleus.form.builder.perms.tabs.onviosetup',
                    'nucleus.form.builder.perms.tabs.timeandbilling',
                    'nucleus.form.builder.perms.tabs.workpapers',
                    'nucleus.form.builder.perms.tabs.fixedassets',
                    'nucleus.form.builder.perms.tabs.tax',
                    'nucleus.form.builder.perms.tabs.autax',
                    'nucleus.form.builder.perms.tabs.catax',
                    'nucleus.form.builder.perms.tabs.cataxt1',
                    'nucleus.form.builder.perms.tabs.cataxt2',
                    'nucleus.form.builder.perms.tabs.cataxt3',
                    'nucleus.form.builder.perms.tabs.cataxt5013',
                    'nucleus.form.builder.perms.tabs.taxt1',
                    'nucleus.form.builder.perms.tabs.taxt2',
                    'nucleus.form.builder.perms.tabs.taxt3',
                    'nucleus.form.builder.perms.tabs.taxt5013',
                    'nucleus.form.builder.perms.tabs.uktaxmtd',
                    'nucleus.form.builder.perms.tabs.ustax',
                    'nucleus.form.builder.perms.tabs.checkpointengage',
                    'nucleus.form.builder.perms.tabs.secretarial',
                    'nucleus.form.builder.perms.tabs.fiscalsincerity',
                    'nucleus.form.builder.perms.tabs.reporting',
                    'nucleus.form.builder.perms.tabs.fileshare',
                    'nucleus.form.builder.perms.tabs.projectmanager',
                    'nucleus.form.builder.perms.tabs.investmentaccounts',
                    'nucleus.form.builder.perms.tabs.checkpoint',
                    'nucleus.form.builder.perms.tabs.novedadesyvencimientos',
                    'nucleus.form.builder.perms.tabs.trialbalance',
                    'nucleus.form.builder.perms.tabs.estudioone',
                    'nucleus.form.builder.perms.tabs.news',
                    'nucleus.form.builder.perms.tabs.devtools',
                    'nucleus.form.builder.perms.tabs.settings',
                    'nucleus.form.builder.perms.tabs.fee',
                    'nucleus.form.builder.perms.tabs.atendimento',
                    'nucleus.form.builder.perms.tabs.box-e',
                    'nucleus.form.builder.perms.tabs.ukcompanyformations',
                    'nucleus.form.builder.perms.tabs.accounts',
                    'nucleus.form.builder.perms.tabs.vat',
                    'nucleus.form.builder.perms.tabs.servicerequestadmin',
                    'nucleus.form.builder.perms.tabs.advisorytools',
                    'nucleus.form.builder.perms.tabs.activitystatements',
                    'nucleus.form.builder.perms.tabs.onbalancedashboards',
                    'nucleus.form.builder.perms.tabs.onbalancepermissions',
                    'nucleus.form.builder.perms.tabs.onbalancereports',
                    'nucleus.form.builder.perms.tabs.custos',
                    'nucleus.form.builder.perms.tabs.grossincometax',
                    'nucleus.form.builder.perms.tabs.clientdashboard',
                    'nucleus.form.builder.perms.tabs.firmdashboard',
                    'nucleus.form.builder.perms.tabs.k-1analyzer',
                    'nucleus.form.builder.perms.tabs.incometax',
                    'nucleus.form.builder.perms.tabs.chat',
                    'nucleus.form.builder.perms.tabs.gesttaprocess',
                    'nucleus.form.builder.perms.tabs.taxdashboard',
                    'nucleus.form.builder.perms.tabs.ecomex',
                    'nucleus.form.builder.perms.tabs.confirmationassetverification',
                    'nucleus.form.builder.perms.tabs.brtax',
                    'nucleus.form.builder.perms.tabs.braccounting',
                    'nucleus.form.builder.perms.tabs.brpayroll',
                    'nucleus.form.builder.perms.tabs.uktaxsa',
                    'nucleus.form.builder.perms.tabs.briceberg',
                    'nucleus.form.builder.perms.tabs.general',
                    'nucleus.form.builder.perms.tabs.kolossusauditor',
                    'nucleus.form.builder.perms.tabs.api'
                ]);

            transPromise.then(function(translations) {
                for (var key in translations) {
                    $scope.strings[key.replace('nucleus.form.builder.perms.', '')] = translations[key];
                }
            });
        };

        // translate promise doesn't resolve on browser refresh unless delayed till next cycle
        $timeout(translateDynamicStrings);
        // handle lang change
        $rootScope.$on('bmLanguageChangeSuccess', translateDynamicStrings);
    }

    PermissionsFormCtrl.$inject = ['$rootScope', '$scope', '$translate', '$q', '$timeout', 'bmPermission', 'bmAccess'];

    function PermissionsFormRowDirective() {
        return {
            restrict: 'A',
            scope: true,
            templateUrl: 'components/permissions-form/permissions-form-row.2js.html'
        };
    }

})(window.angular);

angular.module('@onviobr/nucleus.form.builder.permissions-form.templates', ['components/permissions-form/permissions-form-fieldset.2js.html', 'components/permissions-form/permissions-form-row.2js.html', 'components/permissions-form/permissions-form.2js.html']);

angular.module("components/permissions-form/permissions-form-fieldset.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permissions-form/permissions-form-fieldset.2js.html",
    "<legend class=\"nucleus-perms-title\">\n" +
    "    <div tabindex=\"-1\" class=\"nucleus-perms-title-header\" id=\"{{node.displayName.replaceAll(' ', '-')}}\">\n" +
    "        <h1>{{node.title}}</h1>\n" +
    "    </div>\n" +
    "    <span ng-repeat=\"label in node.labels\" ng-class=\"{label: true, 'label-info': label.type === 'success'}\">\n" +
    "        {{label.text}}\n" +
    "    </span>\n" +
    "    <a ng-repeat=\"link in node.links\" href=\"{{link.href}}\" target=\"_blank\">{{link.text}}</a>\n" +
    "</legend>\n" +
    "\n" +
    "<p>{{node.description}}\n" +
    "    <i ng-if=\"node.help\" uib-tooltip-placement=\"bottom\" uib-tooltip-append-to-body=\"true\" uib-tooltip=\"{{node.help}}\" class=\"bento-icon-info\"></i>\n" +
    "</p>\n" +
    "\n" +
    "<div ng-if=\"isType(node, 'filteredPerm')\">\n" +
    "    <fieldset ng-repeat=\"node in node.children\" ng-include=\"'components/permissions-form/permissions-form-fieldset.2js.html'\"></fieldset>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-if=\"isType(node, 'filterSet')\">\n" +
    "    <label ng-repeat=\"node in node.children\" class=\"checkbox-inline\">\n" +
    "        <input ng-disabled=\"readOnly\" type=\"checkbox\" ng-model=\"node.value\">\n" +
    "        {{node.title}}\n" +
    "    </label>\n" +
    "</div>\n" +
    "\n" +
    "<!-- needs to match two types, so we can't use ng-switch -->\n" +
    "<div ng-if=\"isType(node, ['permToggle', 'filterToggle'])\">\n" +
    "    <div class=\"btn-group\">\n" +
    "        <!-- isolate transient showDetails value from inheritance by using [$id] -->\n" +
    "        <button ng-disabled=\"readOnly\" type=\"button\" class=\"btn btn-default btn-toggle\" data-qe-id=\"bmstaff-permgrpsdetail-{{formatNodeTitleForAttrib(node.key)}}-noperm-btn\" ng-class=\"{ 'btn-primary': node.value==='NONE' }\" ng-model=\"node.value\" uib-btn-radio=\"'NONE'\" ng-change=\"none()\" ng-click=\"showDetails[$id] = (!showDetailsDirty[$id] && node.value === 'SOME') ? false : showDetails[$id]\">\n" +
    "            {{ node.optionLabels.NONE || strings.nothing }}\n" +
    "        </button>\n" +
    "        <!-- isolate transient showDetails value from inheritance by using [$id] -->\n" +
    "        <button ng-disabled=\"readOnly\" type=\"button\" class=\"btn btn-default btn-toggle\" data-qe-id=\"bmstaff-permgrpsdetail-{{formatNodeTitleForAttrib(node.key)}}-allperm-btn\" ng-class=\"{ 'btn-primary': node.value==='ALL' }\" ng-model=\"node.value\" uib-btn-radio=\"'ALL'\" ng-change=\"all()\" ng-click=\"showDetails[$id] = (!showDetailsDirty[$id] && node.value === 'SOME') ? false : showDetails[$id]\">\n" +
    "            {{ node.optionLabels.ALL || strings.everything }}</button>\n" +
    "        <!-- ng-if creates a new scope, set transient showDetails value (isolate via [$id]) on parent -->\n" +
    "        <button ng-disabled=\"readOnly\" ng-if=\"hasChildren(node)\" type=\"button\" class=\"btn btn-default btn-toggle\" data-qe-id=\"bmstaff-permgrpsdetail-{{formatNodeTitleForAttrib(node.key)}}-someperm-btn\" ng-class=\"{ 'btn-primary': node.value==='SOME' }\" ng-model=\"node.value\" uib-btn-radio=\"'SOME'\" ng-change=\"some()\" ng-click=\"$parent.showDetails[$parent.$id] = true\">\n" +
    "            {{ node.optionLabels.SOME || strings.custom }}</button>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"hasChildren(node)\">\n" +
    "        <div ng-init=\"$parent.showDetails[$parent.$id] = node.value === 'SOME' || readOnly\"></div>\n" +
    "        <!-- ng-if creates a new scope, set transient showDetails value (isolate via [$id]) on parent -->\n" +
    "        <button tabindex=\"0\" aria-expanded=\"{{$parent.showDetails[$parent.$id] || false}}\" data-qe-id=\"bmstaff-permgrpsdetail-hidedetails\" class=\"detailsToggle\"  ng-click=\"$parent.showDetailsDirty[$parent.$id] = true; $parent.showDetails[$parent.$id] =! $parent.showDetails[$parent.$id] \">\n" +
    "            <span ng-if =\"!$parent.showDetails[$parent.$id]\" translate=\"nucleus.form.builder.perms.showdetails\"></span>\n" +
    "            <span ng-if =\"$parent.showDetails[$parent.$id]\" translate=\"nucleus.form.builder.perms.hidedetails\"></span>\n" +
    "        </button>\n" +
    "        <div ng-show=\"$parent.showDetails[$parent.$id]\" class=\"detailsSlide\">\n" +
    "            <fieldset class=\"{{node.type}}\" ng-repeat=\"node in node.children\" ng-include=\"'components/permissions-form/permissions-form-fieldset.2js.html'\"></fieldset>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-if=\"isType(node, 'permTable')\" class=\"table-responsive\">\n" +
    "    <table class=\"table table-condensed table-bordered\">\n" +
    "        <thead>\n" +
    "            <th></th>\n" +
    "            <th>\n" +
    "                <div>{{ node.optionLabels.FULL || strings.full }}</div>\n" +
    "                <input ng-disabled=\"readOnly\" type=\"checkbox\" ng-model=\"full\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "            </th>\n" +
    "            <th>\n" +
    "                <div>{{ node.optionLabels.VIEW || strings.view }}</div>\n" +
    "                <input ng-disabled=\"readOnly\" type=\"checkbox\" ng-model=\"view\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "            </th>\n" +
    "            <th>\n" +
    "                <div>{{ node.optionLabels.ADD || strings.add }}</div>\n" +
    "                <input ng-disabled=\"readOnly\" type=\"checkbox\" ng-model=\"add\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "            </th>\n" +
    "            <th>\n" +
    "                <div>{{ node.optionLabels.EDIT || strings.edit }}</div>\n" +
    "                <input ng-disabled=\"readOnly\" type=\"checkbox\" ng-model=\"edit\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "            </th>\n" +
    "            <th>\n" +
    "                <div>{{ node.optionLabels.DELETE || strings.delete }}</div>\n" +
    "                <input ng-disabled=\"readOnly\" type=\"checkbox\" ng-model=\"delete\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "            </th>\n" +
    "        </thead>\n" +
    "        <tbody ng-repeat=\"node in node.children\" nucleus-permissions-form-row></tbody>\n" +
    "    </table>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/permissions-form/permissions-form-row.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permissions-form/permissions-form-row.2js.html",
    "<tr ng-class=\"{ permRollupRow: hasChildren(node) }\">\n" +
    "    <td>\n" +
    "        {{node.title}}\n" +
    "    </td>\n" +
    "    <td>\n" +
    "        <input ng-if=\"hasOption(node, 'FULL')\" type=\"checkbox\" ng-model=\"full\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "    </td>\n" +
    "    <td>\n" +
    "        <input ng-if=\"hasOption(node, 'VIEW')\" type=\"checkbox\" ng-model=\"view\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "    </td>\n" +
    "    <td>\n" +
    "        <input ng-if=\"hasOption(node, 'ADD')\" type=\"checkbox\" ng-model=\"add\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "    </td>\n" +
    "    <td>\n" +
    "        <input ng-if=\"hasOption(node, 'EDIT')\" type=\"checkbox\" ng-model=\"edit\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "    </td>\n" +
    "    <td>\n" +
    "        <input ng-if=\"hasOption(node, 'DELETE')\" type=\"checkbox\" ng-model=\"delete\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "    </td>\n" +
    "</tr>\n" +
    "\n" +
    "<!-- The following code for deep row hierarchies works in the nucleus-form-builder demo app,\n" +
    "     but not when the component is used in nucleus staff, maybe shallower scope trees have\n" +
    "     something to do with it?? -->\n" +
    "<!-- <tr ng-repeat=\"node in node.children\" nucleus-permissions-form-row></tr> -->\n" +
    "\n" +
    "<!-- Alternative code that only supports two levels of rows -->\n" +
    "<tr ng-repeat=\"node in node.children\">\n" +
    "    <td>\n" +
    "        {{node.title}}\n" +
    "    </td>\n" +
    "    <td>\n" +
    "        <input ng-if=\"hasOption(node, 'FULL')\" type=\"checkbox\" ng-model=\"full\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "    </td>\n" +
    "    <td>\n" +
    "        <input ng-if=\"hasOption(node, 'VIEW')\" type=\"checkbox\" ng-model=\"view\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "    </td>\n" +
    "    <td>\n" +
    "        <input ng-if=\"hasOption(node, 'ADD')\" type=\"checkbox\" ng-model=\"add\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "    </td>\n" +
    "    <td>\n" +
    "        <input ng-if=\"hasOption(node, 'EDIT')\" type=\"checkbox\" ng-model=\"edit\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "    </td>\n" +
    "    <td>\n" +
    "        <input ng-if=\"hasOption(node, 'DELETE')\" type=\"checkbox\" ng-model=\"delete\" ng-model-options=\"{ getterSetter: true }\">\n" +
    "    </td>\n" +
    "</tr>\n" +
    "");
}]);

angular.module("components/permissions-form/permissions-form.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/permissions-form/permissions-form.2js.html",
    "<form novalidate bento-busy-loader=\"!schema.length\" bento-busy-loader-size=\"small\">\n" +
    "    <uib-tabset ng-if=\"!useSideNav\" class=\"tabs-left\">\n" +
    "        <uib-tab heading=\"{{translateTabName(node.displayName)}}\" data-qe-id=\"bmstaff-permgrpsdetail-{{formatNodeTitleForAttrib(node.displayName)}}-tab\" ng-repeat=\"node in schema\" select=\"tabSelected(node)\">\n" +
    "            <fieldset class=\"{{node.type}}\" ng-include=\"'components/permissions-form/permissions-form-fieldset.2js.html'\" bento-busy-loader=\"!node.type\" bento-busy-loader-size=\"small\"></fieldset>\n" +
    "        </uib-tab>\n" +
    "    </uib-tabset>\n" +
    "\n" +
    "    <div ng-if=\"useSideNav\" class=\"sidenav-container\">\n" +
    "        <div\n" +
    "            bento-tree\n" +
    "            tree-id=\"onvio-usage-tree\"\n" +
    "            tree-model=\"sideNavData\"\n" +
    "            class=\"sideNav\"\n" +
    "            multi-select=\"false\"\n" +
    "            nav-mode=\"true\"\n" +
    "            select-model=\"selected\"\n" +
    "            tree-label=\"label\"\n" +
    "            select-callback=\"sideNavItemSelected\">\n" +
    "        </div>\n" +
    "        <fieldset ng-repeat=\"node in schema\" ng-if=\"node === activeNode\" class=\"{{node.type}} side-nav-item\" ng-include=\"'components/permissions-form/permissions-form-fieldset.2js.html'\" bento-busy-loader=\"!node.type\" bento-busy-loader-size=\"small\"></fieldset>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);
